import ActionType from '../actionTypes/saveDesignActionType';
import Design from '../../objects/graphicsLibrary/design';

export interface SaveDesignState {
    saveDesign: CommonState & {
        data: Design | null;
    };
    saveImages: CommonState & {
        data: Design | null;
    };
    saveDesignName: CommonState;
}

interface CommonState {
    failed: boolean;
    loading: boolean;
    success: boolean;
    finished: boolean;
}

interface SaveDesignAction {
    type: string;
    data: Design;
}

const commonState = {
    failed: false,
    loading: false,
    success: false,
    finished: false,
};

const stateSaveDesign = 'saveDesign';
const stateSaveImages = 'saveImages';
const stateSaveDesignName = 'saveDesignName';
type SubState =
    | typeof stateSaveDesign
    | typeof stateSaveImages
    | typeof stateSaveDesignName;

const getInitialState = (): SaveDesignState => ({
    [stateSaveDesign]: {
        ...commonState,
        data: null,
    },
    [stateSaveImages]: {
        ...commonState,
        data: null,
    },
    [stateSaveDesignName]: {
        ...commonState,
    },
});

const start = (
    subStateName: SubState,
    state: SaveDesignState
): SaveDesignState => ({
    ...state,
    [subStateName]: {
        ...state[subStateName],
        failed: false,
        loading: true,
        success: false,
        finished: false,
    },
});

const success = (
    subStateName: SubState,
    state: SaveDesignState,
    action: SaveDesignAction
): SaveDesignState => ({
    ...state,
    [subStateName]: {
        ...state[subStateName],
        failed: false,
        loading: false,
        success: true,
        finished: true,
        data: action.data,
    },
});

const successNoData = (
    subStateName: SubState,
    state: SaveDesignState
): SaveDesignState => ({
    ...state,
    [subStateName]: {
        ...state[subStateName],
        failed: false,
        loading: false,
        success: true,
        finished: true,
    },
});

const fail = (
    subStateName: SubState,
    state: SaveDesignState
): SaveDesignState => ({
    ...state,
    [subStateName]: {
        ...state[subStateName],
        failed: true,
        loading: false,
        success: false,
        finished: true,
    },
});

const reducer = (state = getInitialState(), action: any): SaveDesignState => {
    switch (action.type) {
        case ActionType.saveDesignWithImages.start:
            return start(stateSaveDesign, state);
        case ActionType.saveDesignWithImages.success:
            return success(stateSaveDesign, state, action);
        case ActionType.saveDesignWithImages.fail:
            return fail(stateSaveDesign, state);

        case ActionType.saveOnlyImages.start:
            return start(stateSaveImages, state);
        case ActionType.saveOnlyImages.success:
            return success(stateSaveImages, state, action);
        case ActionType.saveOnlyImages.fail:
            return fail(stateSaveImages, state);

        case ActionType.saveDesignName.start:
            return start(stateSaveDesignName, state);
        case ActionType.saveDesignName.success:
            return successNoData(stateSaveDesignName, state);
        case ActionType.saveDesignName.fail:
            return fail(stateSaveDesignName, state);

        default:
            return state;
    }
};

export default reducer;
